import { Component, Vue } from "vue-property-decorator";
import { MEETING_TYPE } from "../../constants/meeting";
import { ROOM_TYPE } from "../../constants/space";
import { CHAT_TYPE } from "../../constants/chat";
import { mixins } from "vue-class-component";
import Loader from "../loader/loader";
import NotificationEvent from "../notifications/notificationEvent";
import { CANCELLATION_TIME } from "../loader/loader";
import { i18n } from "@/resources/locales";
import { RED } from "../../constants/busyReasons";
@Component({})
export default class ConnectToRoomCall extends mixins(
  Loader,
  NotificationEvent
) {
  async connectToRoomCall(store, roomId: number, pinToJoin = null) {
    /* Validar si esta o no en llamada y que tipo de llamada es */
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve, reject) => {
      const isCall = await store?.getters["SidebarStore/getOpenCall"];
      const typeCall = await store?.getters["MeetingStore/getMeetingType"];
      /*esta en llamada y es ONE TO ONE */
      if (isCall && typeCall == MEETING_TYPE.ONE_TO_ONE) {
        const meeting = await store?.getters["MeetingStore/getMeeting"];
        const attendee = await store?.getters["MeetingStore/getAttendee"];
        await store?.dispatch("UserStore/loadPreviousStatusAction", {
          store: store,
          callback: (response) => {
            store?.dispatch("SpaceStore/updateUserInSpace", response.data);
          },
        });
        await store?.dispatch("MeetingStore/closeMeetingOneToOneAction", {
          meetingId: meeting.MeetingId,
          attendee: attendee.AttendeeId,
          callback: (response) => {
            store?.dispatch("SidebarStore/setOpenCall", false);
            store?.dispatch("ChatStore/setMinimizeChatAction", false);
          },
          callbackError: (error) => {
            store?.dispatch("SidebarStore/setOpenCall", false);
            store?.dispatch("ChatStore/setMinimizeChatAction", false);
          },
        });
      }
      /* CANCELAR CUALQUIER LLAMADA */
      await store?.dispatch("MeetingStore/closeMeetingSession");
      /* BUSCAR EL ESPACIO Y LA SALA */
      const space = store?.getters["SpaceStore/getSpace"];
      const room = space.scenario.rooms.filter((room) => room.id === roomId)[0];
      /* NORMAL MEETING OR WEBINAR */
      if (
        room.type === ROOM_TYPE.MEETING ||
        room.type === ROOM_TYPE.WEBINAR ||
        room.type === ROOM_TYPE.GAME
      ) {
        await store?.dispatch("MeetingStore/joinMeetingAction", {
          roomId: roomId,
          pinToJoin: pinToJoin,
          callback: async (response) => {
            if (
              response.data.status == "JOINING" ||
              response.data.status == "OK"
            ) {
              await this.startLoader(store, CANCELLATION_TIME.CANCEL_CALL_30);
              this.setLoaderText(
                store,
                i18n.t("loader.connectingRoom").toString()
              );

              /* RESTART CHAT */
              await store?.dispatch("ChatStore/removeUnSeenMessageAction", {
                id: null,
                type: CHAT_TYPE.ROOM,
              });
              await store?.dispatch("ChatStore/setMessagesAction", []);
              await store?.dispatch("SidebarStore/setOpenChatAction", false);
              await store?.dispatch("ChatStore/setUserChatAction", null);
              await store?.dispatch(
                "ChatStore/setChatTypeAction",
                CHAT_TYPE.ROOM
              );
              setTimeout(async () => {
                const space = store?.getters["SpaceStore/getSpace"];
                if (
                  room.type === ROOM_TYPE.MEETING ||
                  (room.type === ROOM_TYPE.WEBINAR && space.isWebinarChatActive)
                ) {
                  await store?.dispatch("SidebarStore/setOpenChatAction", true);
                }
              }, 50);
              /* RESTART CHAT */

              if (room.type === ROOM_TYPE.WEBINAR) {
                await store?.dispatch(
                  "MeetingStore/setWebinarActiveAction",
                  true
                );
              }
              store?.dispatch("MeetingStore/setVideoUrlAction", room.videoUrl);
              await store?.dispatch(
                "MeetingStore/setMeetingTypeAction",
                room.type
              );
              await store?.dispatch(
                "MeetingStore/setColumnDisplayAction",
                !(
                  room.videoUrl !== undefined &&
                  room.videoUrl !== "" &&
                  room.videoUrl !== null
                )
              );
              await store?.dispatch("MeetingStore/setRoomIdAction", roomId);
              await store?.dispatch(
                "MeetingStore/setRoomNameAction",
                room.name
              );
              await store?.dispatch("ChatStore/joinRoomChatAction", {
                roomId,
                pinToJoin,
              });
              if (response.data.meeting) {
                await this.changeStatusUser(store);
                await store?.dispatch(
                  "MeetingStore/setMeetingDataAction",
                  response.data
                );
                await store?.dispatch("SidebarStore/setOpenCall", true);
                await store.dispatch(
                  "ChatStore/setMinimizeChatAction",
                  !store?.getters["UserStore/getConfig"].chat
                    .openRoomChatByDefault
                );
              }
              setTimeout(() => {
                store?.dispatch("GraphicClientStore/resizeGraphicClientAction");
              }, 20);
              resolve(true);
            } else {
              this.stopLoader(store);
              resolve(false);
            }
            if (room.type === ROOM_TYPE.GAME) {
              this.openGame(store);
            }
          },
          callbackError: async (error) => {
            await this.stopLoader(store);
          },
        });
      }
      /* SPEED NETWORKING */
      if (room.type === ROOM_TYPE.SPEED_NETWORKING) {
        await store?.dispatch("SidebarStore/setActiveMenuAction", -1);
        await store?.dispatch("MeetingStore/setRoomIdAction", room.id);
        await store?.dispatch("MeetingStore/setRoomNameAction", room.name);
        await store?.dispatch(
          "SpeedNetworkingStore/setShowEnterModalAction",
          true
        );
        Promise.resolve(true);
      }
      /*if (space && space.superSpace && space.superSpace.company == "HAWKINGS") {
        if (room.bot != null) {
          await store?.dispatch("SystemStore/setEducationBotIdAction", room.bot.id);
          await store?.dispatch("SystemStore/setEducationModalAction", true);
        }
      }*/
    });
  }
  async changeStatusUser(store) {
    const userLocal = store?.getters["UserStore/getSpaceUser"];
    const pre_status = {
      availableStatus: userLocal.superSpaceUser.user.availableStatus,
      availableStatusReason:
        userLocal.superSpaceUser.user.availableStatusReason,
      emoji: localStorage.getItem("default_emoji"),
    };
    localStorage.setItem("pre_status", JSON.stringify(pre_status));
    await store?.dispatch("UserStore/updateUserStatusAction", {
      userId: userLocal.superSpaceUser.user.id,
      props: {
        availableStatus: RED.type,
        availableStatusReason: null,
        emoji: "U+1F4DE",
      },
      callback: (user) => {
        store?.dispatch("SpaceStore/updateUserInSpace", user);
      },
    });
  }
  openGame(store): void {
    store?.dispatch("MeetingStore/setActiveGameAction", true);
    store?.dispatch("MeetingStore/setColumnDisplayAction", false);
  }
  async connectToRoomAutoVideo(store, roomId: number, response: any, pinToJoin = null) {
    if (
      response.data.status == "RECORDING" ||
      response.data.status == "OK"
    ) {
      if (response.data.meeting) {
        await this.changeStatusUser(store);
        await store?.dispatch(
          "MeetingStore/setMeetingDataAction",
          response.data
        );
        await store?.dispatch("SidebarStore/setOpenCall", true);
        await store?.dispatch(
          "MeetingStore/setMeetingTypeAction",
          MEETING_TYPE.AUTO_VIDEO
        );
      }
      setTimeout(() => {
        store?.dispatch("GraphicClientStore/resizeGraphicClientAction");
      }, 20);
    } else {
      console.log("TTT connectToRoomAutoVideo KO", response);
      this.stopLoader(store);
    }
  }
}
